import React from 'react';

export default function ThankYou() {
  return (
    <div id="thankyou" className="content">
      <div className="page-banner"></div>
      <div className="page-content">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-8">
              <p>Thanks for applying to Ovatures! We will review your application and be back in touch with you in the next two business days. In the meantime follow us @ovatures on Facebook, Instagram and Twitter to learn more about the egg donation process. Be sure to check out these feeds – they are meant for women just like you!</p>
              <p>Questions? Email us at <a href="mailto:ovatures@ivirma.com" className="color-DB006A">ovatures@ivirma.com</a> or call <a href="tel:973-656-2876" className="color-DB006A">973-656-2876</a>.</p>
              <ul className="clearfix social-media">
                <li><a href="https://www.facebook.com/Ovatures/" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://twitter.com/ovatures" target="_blank" rel="noopener noreferrer"></a></li>
                <li><a href="https://instagram.com/ovatures" target="_blank" rel="noopener noreferrer"></a></li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
